import * as React from "react";
import { RadiosEditor } from "../../../../../../react-core/Html/RadiosEditor";
import { IProcessComponentProps, ProcessComponent } from "../../../../../Shared/Process/Process/ProcessComponent";
import { AdviceGivenQuestionText, FinancialAdviceFirstDrawdownHardStop, FinancialAdviceHardStop } from "../Resource/Contents";
import { SectionHeader } from "../SharedComponents";
import { User } from "../../../../../../Wrap/Models/Models/User/User";
import { UserStore } from "../../../../Stroes/Variable";
import { ProcessType } from "../../../../../Shared/IST/Resource/Content";
import { Lightbox } from "../../../../../../react-core/Html/Components/Lightbox";
interface IFinancialAdviceProps extends IProcessComponentProps {
    processtype? :ProcessType;
    firstMovetoDrawdown? : Boolean;
}

interface IFinancialAdviceState {
    userInfo: User;
    showCOBSWarningMessage: boolean;
}

export class FinancialAdvice extends ProcessComponent<IFinancialAdviceProps, IFinancialAdviceState> {
    constructor(props: any) {
        super(props);
        this.state = {
            userInfo: UserStore.getUserInfo(),
            showCOBSWarningMessage: false
        };
    }

    private renderWarningMessage() {
        return (
            <Lightbox
                unclosable={true}
                noOverlay={false}
                noAutofocus={true}
                cssWrapper="is-default-lightbox" title={""} 
                show={this.state.showCOBSWarningMessage} 
                onClose={() => this.setState({ showCOBSWarningMessage: false })
                }           >
                    <p>I confirm I have met my COBS 19.7 requirements on the provision of retirement risk warnings, where appropriate.</p>
                        <button
                            className="btn primary"
                            onClick={() => this.setState({ showCOBSWarningMessage: false })}
                        >
                            OK
                        </button>
            </Lightbox>
        );
    }
    
    public render(): JSX.Element {
        const { data, onChange } = this.props;
        return (
            <>
                {SectionHeader("Financial advice")}
                <RadiosEditor
                    cssWrapper="radio-group rg-inline rg-150 mb-23"
                    selected={data?.AdviceGiven}
                    options={[true, false]}
                    label={AdviceGivenQuestionText}
                    getText={(v) => (v ? "Yes" : "No")}
                    onChange={(v) =>{
                        this.onDataChange(
                            onChange,
                            {
                                AdviceGiven: v,
                            },
                            data
                        );
                        if(this.state.userInfo?.IsAdviser && FinancialAdviceFirstDrawdownHardStop.includes(this.props?.processtype) && !this.props.firstMovetoDrawdown){
                            this.setState({ showCOBSWarningMessage: !v });}
                        }

                    }
                    required="Please select"
                    validationRules={[
                        {
                            errorMessage: "To continue, you must have given financial advice.",
                            validator: (v) => {
                                if ((this.state.userInfo?.IsAdviser && (FinancialAdviceHardStop.includes(this.props?.processtype) || (FinancialAdviceFirstDrawdownHardStop.includes(this.props?.processtype) && this.props.firstMovetoDrawdown))) || this.props?.processtype == null) {
                                    return v == null ? true : v;
                                }
                                else{
                                    return true
                                } 
                            },
                        },
                    ]}
                />
                {this.state.showCOBSWarningMessage && this.renderWarningMessage()}
            </>
        );
    }
}
